/*
 * Cocooning Baby - Offer Selector Defensive Sync
 * ---------------------------------------------------------------
 * Backup safety net : si Dawn product-info.js ne sync pas
 * correctement la variante selectionnee dans le sélecteur d'offre
 * custom avec le form principal (bouton "Ajouter au panier"),
 * ce script prend le relais et :
 *  1. Ecoute le 'change' sur les inputs radio .cb-offer__radio
 *  2. Lit le JSON des variantes (embedded dans <variant-selects>)
 *  3. Trouve la variante qui correspond a la valeur cochee
 *  4. Met a jour input[name="id"] du form principal
 *  5. Met a jour le prix affiche sur la page produit (best-effort)
 *
 * Charge globalement via theme.liquid pour garantir l'execution.
 */
(function () {
  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  function findFormForRadio(radio) {
    var formId = radio.getAttribute('form');
    if (formId) {
      var f = document.getElementById(formId);
      if (f) return f;
    }
    // Fallback : remonter au form parent OU chercher le form produit principal
    var fallback = document.querySelector('product-form form, form[action$="/cart/add"]');
    return fallback || null;
  }

  function findVariantsForSelector(variantSelects) {
    if (!variantSelects) return null;
    var jsonScript = variantSelects.querySelector('script[type="application/json"]');
    if (!jsonScript) return null;
    try {
      return JSON.parse(jsonScript.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateDisplayedPrice(variant) {
    // Met a jour le prix dans .price__regular / .price__sale (Dawn natif)
    // Sans casser le markup, on ne fait que tenter le best-effort
    if (!variant) return;
    var priceContainers = document.querySelectorAll('[id^="price-"], .price');
    priceContainers.forEach(function (container) {
      var regular = container.querySelector('.price-item--regular');
      var sale = container.querySelector('.price-item--sale');
      var compare = container.querySelector('.price-item--last, .price-item--regular.price-item--last');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (sale) sale.textContent = formatMoney(variant.price);
        if (regular) regular.textContent = formatMoney(variant.compare_at_price);
        container.classList.add('price--on-sale');
      } else {
        if (regular) regular.textContent = formatMoney(variant.price);
        container.classList.remove('price--on-sale');
      }
    });
  }

  function onRadioChange(e) {
    var radio = e.target;
    if (!radio || !radio.classList || !radio.classList.contains('cb-offer__radio')) return;
    if (!radio.checked) return;

    // Conteneur = .cbo (les pastilles couleur sont HORS du <variant-selects>)
    var container = radio.closest('.cbo') || radio.closest('variant-selects, variant-radios');
    if (!container) return;
    var variantSelects = container.querySelector('variant-selects, variant-radios') || container;

    var variants = findVariantsForSelector(variantSelects);
    if (!variants || !variants.length) return;

    // Met a jour l'etiquette "Couleur : X" quand on change une pastille
    if (radio.classList.contains('cbo__swradio')) {
      var optName = radio.getAttribute('name');
      var lbl = container.querySelector('.cbo__opt-val[data-cbo-optval="' + (optName || '') + '"]');
      if (lbl) lbl.textContent = radio.value;
    }

    // Toutes les valeurs cochees (couleur + offre) dans ce sélecteur
    var selValues = [];
    container.querySelectorAll('.cb-offer__radio:checked').forEach(function (r) {
      selValues.push(r.value);
    });

    // Matching par combinaison de valeurs (les valeurs ne se chevauchent pas
    // entre Couleur et Offre, donc un set de valeurs identifie un variant unique)
    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      if (opts.length !== selValues.length) continue;
      var ok = true;
      for (var j = 0; j < selValues.length; j++) {
        if (opts.indexOf(selValues[j]) === -1) { ok = false; break; }
      }
      if (ok) { matched = variants[i]; break; }
    }
    // Fallback mono-option
    if (!matched) {
      for (var k = 0; k < variants.length; k++) {
        if (variants[k].option1 === radio.value || variants[k].title === radio.value) {
          matched = variants[k];
          break;
        }
      }
    }
    if (!matched) return;

    var form = findFormForRadio(radio);
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = matched.id;
        // Declencher un input event pour que Dawn (et d'autres scripts) reagissent
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateDisplayedPrice(matched);

    // Notifier les autres scripts custom (sticky CTA, etc.)
    document.dispatchEvent(new CustomEvent('cb:variant:change', {
      detail: { variant: matched },
      bubbles: true
    }));
  }

  // Event delegation sur document : marche meme si le sélecteur
  // est rendu dynamiquement
  document.addEventListener('change', onRadioChange);

  // Sync initial au chargement de la page : si une variante est
  // déjà cochee (checked attribute), on la sync immediatement
  function syncInitialState() {
    var checkedRadios = document.querySelectorAll('.cb-offer__radio:checked');
    checkedRadios.forEach(function (radio) {
      onRadioChange({ target: radio });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitialState);
  } else {
    syncInitialState();
  }
})();
